import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AddNewBatchRedirectModal = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    navigate('/claims/batches'); // Redirect back to the list
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform transition-all">
        {/* Header with Icon */}
        <div className="bg-amber-50 p-6 flex flex-col items-center">
          <div className="bg-amber-100 p-3 rounded-full mb-4">
            <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-slate-800 uppercase tracking-wide">Feature Relocated</h3>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-slate-600 text-sm leading-relaxed mb-4 text-center">
            {/* Creating batches is no longer allowed on this platform. This process has been moved to our centralized system. */}
            <b>"Add New Batch"</b> features is no longer allowed here. This process has been moved to a centralized system (Claims Receiving) where you can manage all your claims batches in one place. Please follow the steps below to access the new system and continue managing your claims batches seamlessly.
          </p>
          
          <div className="space-y-4">
            <div className="bg-slate-50 p-3 rounded-lg border border-slate-100">
              <span className="text-[10px] font-bold text-slate-400 uppercase block mb-1">Step 1: Claims Received & Create Batch</span>
              <a href="https://allaccess.amaphil.com.ph/claims/receiving" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline font-medium text-sm break-all">
                https://allaccess.amaphil.com.ph/claims/receiving
              </a>
            </div>

            <div className="bg-slate-50 p-3 rounded-lg border border-slate-100">
              <span className="text-[10px] font-bold text-slate-400 uppercase block mb-1">Step 2: Edit Existing Batch</span>
              <a href="https://allaccess.amaphil.com.ph/claims/batches" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline font-medium text-sm break-all">
                https://allaccess.amaphil.com.ph/claims/batches
              </a>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <div className="p-6 pt-0">
          <button
            onClick={handleClose}
            className="w-full bg-slate-800 hover:bg-slate-900 text-white font-semibold py-3 rounded-xl transition-colors shadow-lg shadow-slate-200"
          >
            Got it, take me back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNewBatchRedirectModal;